import { getTableColumns } from "@/pages/consumption/view/billing/config/table-columns";
import { useEffect, useState } from "react";

const columns = getTableColumns();

export function useTableColumns() {
  const { filterValue, setFilterValue } = useAppealStatusOnFilter();

  return { columns, filterValue, setFilterValue };
}

export function useAppealStatusOnFilter() {
  const [filterValue, setFilterValue] = useState<any[] | null>();

  useEffect(() => {
    columns.some((c) => {
      if (c.dataIndex === "appealStatus") {
        c.filteredValue = filterValue;
        return true;
      }
      return false;
    });
  }, [filterValue]);

  return { filterValue, setFilterValue };
}
